<template>
    <div class="top-nav_search">
        <button class="button search">
            <search-icon size="1.5x" class="svg-fill"></search-icon>
        </button>
        <input class="top-nav_input"
               placeholder="Поиск"
               type="text"/>
    </div>
</template>

<script>
    import { SearchIcon } from 'vue-feather-icons'

    export default {
        name: "SearchInput",
        components: {
            SearchIcon
        }
    };
</script>

<style scoped lang="scss">
    .top-nav {
        &_search {
            display: flex;
            padding: 12px 24px 12px 20px;
            input{
                background: transparent;
                border: none;
                font-size: 14px;
                width: 100%;
            }
            .search {
                margin-right: 5px;
            }
        }
    }
</style>
